module.exports = __webpack_public_path__ + "static/media/profileImg.c5eb4ded.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/profileImg.png
// module id = 648
// module chunks = 1